module.exports = __webpack_public_path__ + "img/4.cc4fa341.jpg";